import React from 'react';
import './UpcomingConferences.css';

const UpcomingConferences = () => {
  const conferences = [
    {
      id: 1,
      title: 'AICIS 2026 Global Summit',
      date: '25-28 November 2026',
      location: 'Abuja, Nigeria',
      theme: 'Africa Infrastructure, Climate Change, Security & Green Investment Summit',
      image: '/images/aicis-2026-bg.png',
      link: 'https://aicis2026.abvig.com/'
    },
    {
      id: 2,
      title: 'AICIS New York',
      date: '29–30 September 2026',
      location: 'New York, USA',
      theme: 'Africa Infrastructure & Investment Summit',
      image: '/images/n-w.jpg',
      link: '/aicis-new-york-2026'  // ← Changed from '#' to the new page
    },
    // {
    //   id: 3,
    //   title: 'AICIS USA',
    //   date: 'Date to be communicated soon',
    //   location: 'USA',
    //   theme: 'Africa Infrastructure & Investment Summit',
    //   image: '/images/usa.jpg',
    //   link: '#'
    // },
    {
      id: 4,
      title: 'AICIS Europe',
      date: 'Date to be communicated soon',
      location: 'Europe',
      theme: 'Africa Infrastructure & Investment Summit',
      image: '/images/europe.jpg',
      link: '#'
    },
    {
      id: 5,
      title: 'AICIS Canada',
      date: 'Date to be communicated soon',
      location: 'Canada',
      theme: 'Africa Infrastructure & Investment Summit',
      image: '/images/canada.jpg',
      link: '#'
    }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Upcoming Conferences</h1>
        <p>Future AICIS conference and summit events</p>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="summit-list">
            {conferences.map((conference) => (
              <a 
                href={conference.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="summit-card-link"
                key={conference.id}
              >
                <div className="summit-card">
                  <div 
                    className="summit-image" 
                    style={{
                      backgroundImage: `url(${conference.image})`,
                      backgroundPosition: '50% 20%',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat'
                    }}
                  ></div>
                  <div className="summit-info">
                    <h3>{conference.title}</h3>
                    <p><strong>Date:</strong> {conference.date}</p>
                    <p><strong>Location:</strong> {conference.location}</p>
                    <p><strong>Theme:</strong> {conference.theme}</p>
                    <span className="summit-link-text">
                      {conference.link !== '#' ? 'Register Now →' : 'Coming Soon →'}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default UpcomingConferences;